import React, { Component } from 'react';
import style from './style/textblock.scss';


export default class TextBlock extends Component {
    render() {
        const { children, classes = { root: {} } } = this.props;

        // this will probably be replaced by an EditableTextBlock component at some point

        return (
            <div className={ `${style.textblock}` } style={ classes.root ? classes.root : '' }>
                { children }
            </div>
        );
    }
}
